import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min';
import 'util/icons';
import 'filter/i18n';
import logger from 'util/logger';
import CommonMixin from 'mixins/common-mixin';

logger.init();

export default {
  install(Vue) {
    Vue.mixin(CommonMixin);
  }
};
